import { AbstractControl, ValidationErrors } from '@angular/forms';

export function removeSpaces(
  control: AbstractControl
): ValidationErrors | null {
  if (control?.value && typeof control.value === 'string') {
    if (!control.value.replace(/\s/g, '').length) {
      return { required: true };
    }
  }
  return null;
}
